const LICENSE_PLATE_PARTS_PATTERN = new RegExp("[A-Z]+|[0-9]+", "g");
const LICENSE_PLATE_PATTERNS = [
  // 1	1951	XX-99-99
  new RegExp("^[A-Z]{2}-?[0-9]{2}-?[0-9]{2}$"),
  // 2	1965	99-99-XX
  new RegExp("^[0-9]{2}-?[0-9]{2}-?[A-Z]{2}$"),
  // 3	1973	99-XX-99
  new RegExp("^[0-9]{2}-?[A-Z]{2}-?[0-9]{2}$"),
  // 4	1978	XX-99-XX
  new RegExp("^[A-Z]{2}-?[0-9]{2}-?[A-Z]{2}$"),
  // 5	1991    XX-XX-99
  new RegExp("^[A-Z]{2}-?[A-Z]{2}-?[0-9]{2}$"),
  // 6	1999	99-XX-XX
  new RegExp("^[0-9]{2}-?[A-Z]{2}-?[A-Z]{2}$"),
  // 7	2005	99-XXX-9
  new RegExp("^[0-9]{2}-?[A-Z]{3}-?[0-9]{1}$"),
  // 8	2009	9-XXX-99
  new RegExp("^[0-9]{1}-?[A-Z]{3}-?[0-9]{2}$"),
  // 9	2006	XX-999-X
  new RegExp("^[A-Z]{2}-?[0-9]{3}-?[A-Z]{1}$"),
  // 10	2008	X-999-XX
  new RegExp("^[A-Z]{1}-?[0-9]{3}-?[A-Z]{2}$"),
  // 11	2015	XXX-99-X
  new RegExp("^[A-Z]{3}-?[0-9]{2}-?[A-Z]{1}$"),
];

/**
 * @param licensePlate License plate to validate
 * @returns {boolean} true if license plate is valid
 */
export function isLicensePlateValid(licensePlate) {
  licensePlate = (licensePlate || "").toUpperCase();

  return (
    licensePlate &&
    LICENSE_PLATE_PATTERNS.some(function(regex) {
      return regex.test(licensePlate);
    })
  );
}

/**
 * Formats the license plate. Convert to uppercase and add hyphens.
 *
 * @param licensePlate License plate to format
 * @returns {string} Formatted uppercase license.
 */
export function formatLicensePlate(licensePlate) {
  var parts;

  licensePlate = (licensePlate || "").toUpperCase();

  // When license plate is not valid return license plate
  if (!isLicensePlateValid(licensePlate)) {
    return licensePlate;
  }

  parts = licensePlate.match(LICENSE_PLATE_PARTS_PATTERN);

  return [].concat
    .apply(
      [],
      parts.map(function(part) {
        return part.length === 4 ? part.match(/.{2}/g) : part;
      })
    )
    .join("-");
}
